module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book_comment_item"
  }, [(_vm.item.title) ? _c('router-link', {
    staticClass: "title",
    attrs: {
      "tag": "h3",
      "to": {
        name: 'commentDetail',
        params: {
          commentPara: 'product_id=' + _vm.item.product_id + '&main_product_id=' + _vm.item.main_product_id + '&product_category=' + _vm.item.category_path + '&comment_cust_id=' + _vm.item.customer_id + '&order_id=' + _vm.item.order_id + '&shop_id=' + _vm.item.shop_id + '&comment_type=' + _vm.commentType + '&comment_id=' + _vm.item.comment_id
        }
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.item.title) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fabulous clearFix"
  }, [_c('star', {
    staticClass: "fl",
    attrs: {
      "score": _vm.item.score
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fabulous_hand fr clearFix"
  }, [_c('good', {
    attrs: {
      "good-num": _vm.item
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fabulous_hand_common fl"
  }, [_c('div', {
    staticClass: "repaly"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "reply_text",
    attrs: {
      "dd_name": "评论回复按钮",
      "to": {
        name: 'commentDetail',
        params: {
          commentPara: 'product_id=' + _vm.item.product_id + '&main_product_id=' + _vm.item.main_product_id + '&product_category=' + _vm.item.category_path + '&comment_cust_id=' + _vm.item.customer_id + '&order_id=' + _vm.item.order_id + '&shop_id=' + _vm.item.shop_id + '&fromReply=true' + '&comment_type=' + _vm.commentType + '&comment_id=' + _vm.item.comment_id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.item.total_reply_num == 0 ? '回复' : _vm.item.total_reply_num))])], 1)], 1)], 1), _vm._v(" "), _c('router-link', {
    staticClass: "comment_text",
    attrs: {
      "to": {
        name: 'commentDetail',
        params: {
          commentPara: 'product_id=' + _vm.item.product_id + '&main_product_id=' + _vm.item.main_product_id + '&product_category=' + _vm.item.category_path + '&comment_cust_id=' + _vm.item.customer_id + '&order_id=' + _vm.item.order_id + '&shop_id=' + _vm.item.shop_id + '&comment_type=' + _vm.commentType + '&comment_id=' + _vm.item.comment_id
        }
      }
    }
  }, [_c('div', {
    ref: "comment_text_p",
    staticClass: "comment_text_p",
    class: this.commentType == 1 ? 'comment_maxline3' : 'comment_maxline'
  }, [_c('top-wonder', {
    attrs: {
      "comment": _vm.item
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.content)
    }
  })], 1), _vm._v(" "), _c('span', {
    class: _vm.showClass
  }, [_vm._v("查看全部")])]), _vm._v(" "), _c('a', {
    staticClass: "clearFix",
    attrs: {
      "href": _vm.item.product_url || 'javascript:;'
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.item.image_url),
      expression: "item.image_url"
    }],
    staticClass: "fl",
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "describe"
  }, [_c('p', {
    staticClass: "omit"
  }, [_vm._v(_vm._s(_vm.item.product_name || '暂无书名'))]), _vm._v(" "), _c('div', {
    staticClass: "omit"
  }, [_vm._v(_vm._s(_vm.item.author_name || '暂无作者信息'))])])]), _vm._v(" "), (_vm.errobj.type) ? _c('popup', {
    attrs: {
      "pop-obj": _vm.errobj
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64cb9c48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bookcomment.vue
// module id = 223
// module chunks = 3